import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/common/base/base.service';
import { UserScheduleTypeSubscription } from '../models/user-schedule-type-subscription';

@Injectable({
  providedIn: 'root'
})
export class UserScheduleTypeSubscriptionService extends BaseService<UserScheduleTypeSubscription, number> {

  constructor(protected override injector: Injector) {
    super(injector, '/user_schedule_type_subscription');
  }

  readByScheduleType(firstId: number) {
    const url = this.BASE_URL + this.endpoint + '/by_schedule_type/' + firstId;
    return this.http.get<UserScheduleTypeSubscription[]>(url);
  }
}
